import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  badge: {
    marginLeft: theme.spacing(1),
    padding: '0 6px',
    borderRadius: 10,
    fontSize: '0.72rem',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    border: '1px dashed var(--ui-warn-border)',
    color: 'var(--ui-warn-text)',
  },
}));

/**
 * The mark of a reference the catalog holds no entity for — dashed, like the
 * topology's unresolved nodes, so it reads the same wherever it appears.
 */
export const UnresolvedBadge = () => {
  const classes = useStyles();
  return <span className={classes.badge}>unresolved</span>;
};
